export default "__VITE_ASSET__DwIzE6dy__"